import React, {useEffect} from "react";
import {
  IonToolbar,
  IonImg,
  IonItem,
  isPlatform,
  IonButtons,
  IonButton,
  IonIcon,
  IonRouterLink,
  IonBadge,
  IonModal,
} from "@ionic/react";
import {person, search, cartOutline} from "ionicons/icons";
import {Link} from "react-router-dom";
import {useLazyQuery} from "@apollo/client";

import {AUTOCOMPLETE_PUBLIC_SERVICES_QUERY} from "../graphql/queries/common.query";
import {AuthContext} from "../context/AuthContext";

import {Cart, Search} from "../components";
import Logo from "../assets/images/coslogo.png";

import "./header.layout.css";

const Header = () => {
  const {isLoggedIn, cartList, cartPopOver, setShowPopover, user} =
    React.useContext(AuthContext);

  const [searchText, setSearchText] = React.useState("");
  const [searchResult, setSearchResult] = React.useState<any[]>([]);

  const [searchPopOver, setShowSearchPopover] = React.useState({
    showPopover: false,
    event: undefined,
  });

  const [autoCompletePublicServices] = useLazyQuery(
    AUTOCOMPLETE_PUBLIC_SERVICES_QUERY,
    {
      fetchPolicy: "network-only",
      onCompleted(data) {
        const searchResult = data?.autoCompletePublicServices?.data;
        if (!searchResult) return;

        const featuredItems = searchResult
          .filter((item: any) => item.isFeatured)
          .sort((a: any, b: any) =>
            a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : 0
          );

        const nonFeaturedItems = searchResult
          .filter((item: any) => !item.isFeatured)
          .sort((a: any, b: any) =>
            a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : 0
          );

        const finalData = [featuredItems, nonFeaturedItems].flat();

        setSearchResult(finalData);
      },
    }
  );

  useEffect(() => {
    autoCompletePublicServices({
      variables: {
        search: searchText,
      },
    });
  }, [searchText]);

  return (
    <>
      {isPlatform("android") || isPlatform("ios") ? (
        <IonToolbar className="mobile-navbar" mode="md">
          <IonItem routerLink="/">
            <IonImg src={Logo} />
          </IonItem>

          <IonButtons slot="end" className="navbar-action-buttons">
            <IonButton
              size="small"
              onClick={(e: any) => {
                e.persist();
                setShowSearchPopover({showPopover: true, event: e});
              }}
            >
              <IonIcon slot="icon-only" icon={search} />
            </IonButton>

            <IonRouterLink href={isLoggedIn() ? "/personale" : "/login"}>
              <IonButton size="small">
                <IonIcon slot="icon-only" icon={person} />
              </IonButton>
            </IonRouterLink>
            <div>
              {cartList.length > 0 && (
                <IonBadge color="primary" className="cart-item-badge">
                  {cartList.length}
                </IonBadge>
              )}
              <IonButton
                size="small"
                id="cartMobileRef"
                onClick={(e: any) => {
                  e.persist();
                  setShowPopover({showPopover: true, event: e});
                }}
              >
                <IonIcon slot="icon-only" icon={cartOutline} />
              </IonButton>
            </div>
          </IonButtons>
        </IonToolbar>
      ) : (
        <div className="app-navbar">
          <IonToolbar className="secondary-navbar">
            <div className="secondary-navbar-content">
              <p>
                Milano <a href="tel:+39024048930">+39 02.4048930</a>
              </p>
              <p>
                Monza <a href="tel:+39024048930">+39 039.2100835</a>
              </p>
            </div>
          </IonToolbar>

          <IonToolbar className="primary-navbar">
            <div className="navbar-content">
              <Link to="/">
                <img src={Logo} alt="logo" />
              </Link>

              <div className="navbar-actions">
                <input
                  type="text"
                  className="navbar-search"
                  id="header-search-input"
                  placeholder="Cerca un servizio"
                  value={searchText}
                  onClick={(e: any) => {
                    e.persist();
                    setSearchText(e.target.value);
                    setShowSearchPopover({showPopover: true, event: e});
                  }}
                  onChange={(e: any) => {
                    e.persist();
                    setSearchText(e.target.value);
                    setShowSearchPopover({showPopover: true, event: e});
                  }}
                />

                <div className="flex-center">
                  <IonRouterLink href="/servizi">
                    <IonItem button>Richiedi pratica</IonItem>
                  </IonRouterLink>
                  <p className="seperator-white"> | </p>
                  <IonRouterLink href="/preventivo">
                    <IonItem button>Richiedi preventivo</IonItem>
                  </IonRouterLink>
                </div>

                <IonButtons
                  slot="end"
                  className="navbar-action-buttons desktop-only"
                >
                  {!isLoggedIn() ? (
                    <IonButton
                      size="large"
                      className="desktop-buttons login-button"
                    >
                      <IonIcon slot="start" icon={person} />
                      <IonRouterLink href="/login">
                        <IonItem>Accedi</IonItem>
                      </IonRouterLink>
                    </IonButton>
                  ) : (
                    <IonButton
                      size="large"
                      className="desktop-buttons area-personale"
                    >
                      <IonIcon slot="start" icon={person} />
                      <IonRouterLink href="/personale">
                        <IonItem>
                          {user?.firstName && user?.lastName
                            ? `${user.firstName} ${user.lastName}`
                            : "Area personale"}
                        </IonItem>
                      </IonRouterLink>
                    </IonButton>
                  )}

                  <div>
                    {cartList.length > 0 && (
                      <IonBadge color="primary" className="cart-item-badge">
                        {cartList.length}
                      </IonBadge>
                    )}
                    <IonButton
                      size="small"
                      expand="block"
                      id={"cartRef"}
                      onClick={(e: any) => {
                        e.persist();
                        setShowPopover({showPopover: true, event: e});
                      }}
                    >
                      <IonIcon slot="icon-only" icon={cartOutline} />
                    </IonButton>
                  </div>
                </IonButtons>
              </div>
            </div>
          </IonToolbar>
        </div>
      )}

      <IonModal
        cssClass="auto-height"
        isOpen={cartPopOver.showPopover}
        onDidDismiss={() =>
          setShowPopover({showPopover: false, event: undefined})
        }
      >
        <Cart setShowPopover={setShowPopover} cartPopOver={cartPopOver} />
      </IonModal>

      <IonModal
        cssClass="auto-height-search"
        isOpen={searchPopOver.showPopover}
        onDidDismiss={() =>
          setShowSearchPopover({showPopover: false, event: undefined})
        }
        animated={false}
      >
        <div className="search-inner-content">
          <Search
            searchText={searchText}
            onInputChange={(stuff: any) => {
              setSearchText(stuff.target?.value);
            }}
            searchResult={searchResult}
            hideSearch={() => {
              setShowSearchPopover({showPopover: false, event: undefined});
            }}
          />
        </div>
      </IonModal>
    </>
  );
};

export default Header;
